module.exports = __webpack_public_path__ + "img/16_96.5bb27350.png";